
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Lead, leadPriorityLabels } from './types';
import { Building2, Star } from 'lucide-react';

interface LeadPipelineCardProps {
  lead: Lead;
}

export const LeadPipelineCard: React.FC<LeadPipelineCardProps> = ({ lead }) => {
  const navigate = useNavigate();

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case "low": return "bg-green-100 text-green-800";
      case "medium": return "bg-blue-100 text-blue-800";
      case "high": return "bg-amber-100 text-amber-800";
      case "urgent": return "bg-red-100 text-red-800";
      default: return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <Card 
      className="mb-3 hover:shadow-md transition-shadow cursor-pointer"
      onClick={() => navigate(`/leads/${lead.id}`)}
    >
      <CardHeader className="pb-2 pt-3 px-3">
        <div className="flex justify-between items-start">
          <CardTitle className="text-base font-semibold leading-tight flex items-center">
            <Building2 className="h-4 w-4 mr-2 text-muted-foreground" />
            {lead.name}
          </CardTitle>
          {lead.lead_score > 0 && (
             <Badge variant="outline" className="flex items-center text-xs px-1.5 py-0.5">
                <Star className="mr-1 h-3 w-3 text-yellow-500" />
                {lead.lead_score}
              </Badge>
          )}
        </div>
        {lead.industry && (
          <CardDescription className="text-xs mt-0.5">{lead.industry}</CardDescription>
        )}
      </CardHeader>
      <CardContent className="px-3 pb-3">
        <div className="flex items-center justify-between text-xs">
          <Badge variant="outline" className={`${getPriorityColor(lead.priority)} px-1.5 py-0.5`}>
            {leadPriorityLabels[lead.priority as keyof typeof leadPriorityLabels]}
          </Badge>
          <span className="text-muted-foreground">
            ID: {lead.id.substring(0, 8)}...
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
